export default __webpack_public_path__ + "static/media/Metaverse-logo.91fcec8b.png";